'use strict';

const jQuery = require('jquery');

const ItemTpl = require('./template/item.hbs');
const ButtonTpl = require('./template/button.hbs');

const addOverlay = (config = {}) => {
    let $overlay = jQuery('<div class="overlay-items" />');

    $overlay.on('click', config.onOverlayClick);

    jQuery('.cloud-panel-content').append($overlay);
};

const removeOverlay = () => {
    jQuery('.overlay-items').remove();
};

const hasOverlay = () => {
    return !!jQuery('.overlay-items').length;
};

module.exports.create = (config = {}) => {
    let buttons = config.buttons || [];
    let $item = jQuery(ItemTpl({
        name: config.name,
        id: config.id || config.uid || '',
    }));
    let $btnMore = $item.find('.btn-more');
    let $moreOptions = $item.find('.more-options');

    $btnMore.on('click', function() {
        jQuery(this).toggleClass('active');
        $moreOptions.toggleClass('show');

        if (hasOverlay()) {
            removeOverlay();
        } else {
            addOverlay({
                onOverlayClick: function() {
                    $btnMore.removeClass('active');
                    $moreOptions.removeClass('show');
                    removeOverlay();
                },
            });
        }
    });

    buttons.forEach((button) => {
        let $button = jQuery(ButtonTpl(button));

        $button.on('click', button.onClick);

        $item.find('.more-options').append($button);
    });

    return $item;
};
